if (!customElements.get(`product-info`)) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;
      this.isEnabledStickyContent = this.dataset.enabledStickyContent === 'true';
      if (this.isEnabledStickyContent) {
        this.setStickyHeight();
        window.addEventListener('resize', this.setStickyHeight.bind(this));
        document.addEventListener(`${PRODUCT_EVENT.updatedVariant}${this.sectionId}`, () => {
          this.setStickyHeight();
        });
        if (Shopify.designMode) {
          document.addEventListener("shopify:section:load", (event) => {
            if (!event.target.classList.contains('section-product-details') && !event.target.classList.contains('section-main-product')) return;
            this.setStickyHeight();
          });

          document.addEventListener("shopify:section:reorder", () => {
            this.setStickyHeight();
          });
        }
        this.initResizeObserver();
      }
    }

    initResizeObserver() {
      // 添加点击事件监听作为补充手段（处理动画延迟）
      document.body.addEventListener('click', (e) => {
        if (e.target.closest('.section-product-details') && (e.target.closest('.text-link') || e.target.closest('[x-show]'))) {
          setTimeout(() => {
            window.requestAnimationFrame(() => this.setStickyHeight());
          }, 350); // 等待 Alpine.js 动画结束
        }
      });

      if (!window.ResizeObserver) return;
      this.resizeObserver = new ResizeObserver((entries) => {
        // Prevent infinite loop if setStickyHeight causes resize (unlikely but possible)
        // and debounce slightly to avoid too many calls during animation
        window.requestAnimationFrame(() => this.setStickyHeight());
      });

      const observeElements = () => {
        // 监听 .section-product-details 容器而非内部元素，确保 Block 级高度变化被捕获
        const mediaElements = document.querySelectorAll(`.product-template__media-wrapper[data-section-id="${this.sectionId}"], .section-product-details`);
        mediaElements.forEach((elem) => this.resizeObserver.observe(elem));
      }

      observeElements();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observeElements);
      }
    }

    setStickyHeight() {
      const contentSideEle = this.querySelector(`.product-template__content-wrapper[data-section-id="${this.sectionId}"]`);
      if (window.innerWidth >= MIN_DEVICE_WIDTH.tablet) {
        requestAnimationFrame(() => {
          let totalHeightMediaSide = 0;
          let totalHeightContentSide = 0;
          document.querySelectorAll(`.product-template__media-wrapper[data-section-id="${this.sectionId}"], .section-product-details`).forEach((elem) => {
            totalHeightMediaSide += elem.getBoundingClientRect().height;
          });
          const contentSideEle = this.querySelector(`.product-template__content-wrapper[data-section-id="${this.sectionId}"]`)

          this.querySelectorAll(`.product-template__content-wrapper[data-section-id="${this.sectionId}"]`).forEach((elem) => {
            totalHeightContentSide += elem.getBoundingClientRect().height;
          });

          const contentSideContainerEle = contentSideEle.querySelector(`.product-template__content__container`);
          contentSideEle.style.minHeight = `${totalHeightMediaSide}px`;
          if (totalHeightMediaSide >= contentSideEle.getBoundingClientRect().height) {
            if (contentSideContainerEle) {
              contentSideContainerEle.classList.add(`md:sticky`);
            }
          } else {
            if (contentSideContainerEle) {
              contentSideContainerEle.classList.remove(`md:sticky`);
            }
          }
        })
      } else {
        contentSideEle.style.minHeight = 'auto';
      }
    }
  }

  customElements.define(`product-info`, ProductInfo);
}